export class ListMicrosoft365UsersRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "search",
            "baseName": "search",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMicrosoft365UsersRequest.attributeTypeMap;
    }
    constructor() {
    }
}
